export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M21.2 20l1-.4 1.8-.7c9.6-3.6 15.6-4.9 26-4.9a55.6 55.6 0 0127.4 6h6.2c-2.5-.7-5.1-1.7-8.2-3-9.5-3.7-14.8-5-25.4-5a66 66 0 00-26.7 5l-1.7.7c-2.5 1-4.7 1.7-6.8 2.3h6.4zm0-20C13.2 2.9 8 4 0 4V2c5.7 0 10-.6 14.8-2h6.4zm56.2 0c7.8 3 13.1 4 22.6 4V2c-6.8 0-11.4-.5-16.4-2h-6.2zM0 14c8.4 0 13.7-1.2 22.3-4.4l1.7-.7C33.6 5.3 39.6 4 50 4c10.3 0 15.4 1.2 24.6 5 9.5 3.7 14.8 5 25.4 5v-2a55.6 55.6 0 01-24.6-5C65.9 3.4 60.6 2 50 2a66 66 0 00-26.7 5l-1.7.7A54 54 0 010 12v2z\" clip-rule=\"evenodd\" opacity=\".2\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "100",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 100 20"
  }
};